import { bigtitleInit, bigtitleAnim } from './bigtitle';
import { subtitleInit, subtitleAnim } from './subtitle';
import { paragraphInit, paragraphAnim } from './paragraph';
import { buttonInit, buttonAnim, buttonAnimOut } from './button';
import { arrowButtonInit, arrowButtonAnim } from './arrowButton';
import {
  navigationItemInit,
  navigationItemAnim,
  navigationItemOut,
  navigationItemHoverIn,
  navigationItemHoverOut,
} from './navigationItem';
import {
  toggleInit,
  toggleAnim,
  togglePlay,
  togglePause,
} from './toggle';
import {
  sliderInit,
  sliderAnim,
  slidePrev,
  slideNext,
} from './slider';


const initials = new Map();
const animations = new Map();

initials.set('bigtitle', bigtitleInit);
initials.set('subtitle', subtitleInit);
initials.set('paragraph', paragraphInit);
initials.set('button', buttonInit);
initials.set('arrowButton', arrowButtonInit);
initials.set('navigationItem', navigationItemInit);
initials.set('toggle', toggleInit);
initials.set('slider', sliderInit);

animations.set('bigtitle', bigtitleAnim);
animations.set('subtitle', subtitleAnim);
animations.set('paragraph', paragraphAnim);
animations.set('button', buttonAnim);
animations.set('buttonOut', buttonAnimOut);
animations.set('arrowButton', arrowButtonAnim);
animations.set('navigationItem', navigationItemAnim);
animations.set('navigationItemOut', navigationItemOut);
animations.set('navigationItemHoverIn', navigationItemHoverIn);
animations.set('navigationItemHoverOut', navigationItemHoverOut);
animations.set('toggle', toggleAnim);
animations.set('togglePlay', togglePlay);
animations.set('togglePause', togglePause);
animations.set('slider', sliderAnim);
animations.set('slide-prev', slidePrev);
animations.set('slide-next', slideNext);

export { initials, animations };
